/* eslint-disable */
export const CategoryType = Object.freeze({
    SCOUT_TRAIL_BADGE: Symbol("SCOUT_TRAIL_BADGE"),
    SCOUT_MERIT_BADGE: Symbol("SCOUT_MERIT_BADGE"),
    CUB_TRAIL_BADGE: Symbol("CUB_TRAIL_BADGE"),
    CUB_MERIT_BADGE: Symbol("CUB_MERIT_BADGE")
})

